console.log('sentry -- begin');
import Raven from 'raven-js';
const __env = process.env.NODE_ENV
const isProduction = __env === 'production'
const win = require('global/window');
let sentryConfig = require('../../../config/sentry.config.js');
import AlloyReport from '@tencent/alloy_report';

console.log('sentry -- third module import');

// 页面总pv的monitor
AlloyReport && AlloyReport.monitor(3046073);

let ravenConfig = {
    shouldSendCallback: () => {
        // 上报到总错误量的monitor
        AlloyReport && AlloyReport.monitor(3046074);
        return true;
    }
};

if(process.env.SENTRY_VERSION) {
    ravenConfig.release = process.env.SENTRY_VERSION;
}

console.log('sentry -- config callbegin')

if (isProduction) {
    console.log('已启用sentry');
    Raven && Raven.config(`//${sentryConfig.dnsKey}@report.url.cn/sentry/${sentryConfig.dnsNumber}`, ravenConfig).install();
}
console.log('sentry -- finish');